import { theme } from '@/utils/theme';

export const classes = {
  button: 'rounded-2xl',
  caps: 'capitalize',
  nonCaps: 'normal-case',
  containedBackground: 'bg-orange-3 hover:bg-orange-3 transition-colors',
  containedText: 'text-white',
  border: 'border',
  outlinedBorder: 'border-orange-2 hover:border-orange-3',
  outlinedText: 'text-orange-3',
  text: 'text-orange-3 hover:text-orange-3',
  disabled: 'not-allowed',
};

export const styles = {
  button: {
    border: '1px solid transparent',
    '&:focus': {
      border: `1px solid ${theme.palette['orange-3'].main}`,
    },
  },
};
